export const tagRoutes = [
  {
    component: () => import('@/domains/tags/pages/IndexPage.vue'),
    meta: { requiresAuth: true },
    name: 'tags',
    path: '/tags',
  },
  {
    component: () => import('@/domains/tags/pages/CreatePage.vue'),
    meta: { requiresAuth: true },
    name: 'tags-create',
    path: '/tags/create',
  },
  {
    component: () => import('@/domains/tags/pages/DetailPage.vue'),
    meta: { requiresAuth: true },
    name: 'tags-detail',
    path: '/tags/:id/edit',
  },
]
